import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";
import { SidePanel } from "../../Components";
import { ButtonPrimary, ButtonOutlined } from "../../Components/Buttons.jsx";
import TextInput from "../../Campaign__Create_TeaserEditor/Campaign__Create_TeaserEditor.jsx";
//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------

const SceneLabel = styled.span`
  font-size: 16px;
  color: #aaaaaa;
`;

const MultiInputs = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  margin-top: 18px;
  align-items: flex-end;
`;

const SingleInputWraper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  flex-basis: calc(50% - 5px);
`;

const ColorWrapper = styled(SingleInputWraper)`
  width: auto;
  gap: 8px;
  justify-content: flex-end;

  > span {
    text-align: left;
    margin: 0;
  }
`;

const InputLabel = styled.span`
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 8px;
`;

const CancelButtonWrapper = styled.div`
  margin-right: 12px;
`;

const ColorInputStyles = styled.input.attrs({ type: "color" })`
  opacity: 100%;
  width: 1px;
  height: 1px;
  border: none;
  cursor: pointer;
  border-radius: 50%;
  position: absolute;
  bottom: 0px;
  background-color: transparent;
  ::-webkit-color-swatch {
    border: none;
    border-radius: 50%;
    padding: 0;
    position: absolute;
  }
  ::-moz-color-swatch {
    border: none;
    border-radius: 50%;
    padding: 0;
    position: absolute;
  }
`;

const ColorSelector = styled.div`
  width: 21px;
  height: 21px;
  border: 1px solid #0c0c0c;
  cursor: pointer;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  position: relative;
`;

const TextInputStyles = styled(TextareaAutosize)`
  width: 100%;
  padding: ${(props) => props.padding};
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0.03em;
  text-align: left;
  font-family: "Rubik";
  background-color: transparent;
  animation: "";
  resize: none;
`;

const MaxCharacters = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 10px;
  color: black;
`;

const Line = styled.div`
  background: rgb(227 229 255 / 60%);
  height: 1px;
  margin: 10px 0px;
  width: 100%;
`;

const CustomSidePanel = styled(SidePanel)`
  z-index: 4;
  font-family: "Rubik";
  display: flex;
  flex-direction: column;
`;

const EditorUpdateActions = styled.div`
  font-family: "Rubik", sans-serif;
  display: flex;
  padding: 10px 16px;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 10px;
  background: #1e1f43;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;

  [type="tertiary"] {
    color: white;
    font-size: 14px;
    border-radius: 4px;
    border: 1px solid #7a89f4;
    &:hover {
      background: transparent;
      color: white;
      border: 1px solid #7a89f4;
      border-radius: 4px;
    }
    line-height: 0px;
    padding: 14px 17px;
  }

  [type="primary"] {
    background-color: #36f99f;
    color: black;
    font-size: 14px;
    font-weight: 600;
    border: 1px solid transparent;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
    &:hover {
      background-color: #237f55;
      color: white;
    }
    line-height: 0px;
    padding: 14px 17px;
  }
`;

export {
  CustomSidePanel,
  SceneLabel,
  MultiInputs,
  TextInput,
  SingleInputWraper,
  InputLabel,
  EditorUpdateActions,
  CancelButtonWrapper,
  ButtonPrimary,
  ButtonOutlined,
  ColorInputStyles,
  ColorSelector,
  TextInputStyles,
  MaxCharacters,
  Line,
  ColorWrapper
};
